<template>
  <div style="position: fixed;right: 0;z-index: 1">
    <div class="button-group1">
      <section :key="button.id" v-for="button in buttons">
        <section v-show="menu[button.id]">
          <button class="show-achievement bottom-button" @click="$emit('button-clicked', button.id)">
            <span class="material-icons-outlined">{{button.icon}}</span>
          </button>
        </section>
      </section>
      <button v-show="canShare" class="show-achievement bottom-button" @click="share">
        <span class="material-icons-outlined">share</span>
      </button>
      <button class="show-achievement bottom-button" @click="$emit('button-clicked', 'tweet')">
        <svg viewBox="0 0 32 32" class="tweet-icon">
          <path d="M2 4c4 4 8 8 13 7a6 6 0 0 1 7-7 6 6 0 0 1 4 2 8 8 0 0 0 5-2 8 8 0 0 1-3 4 8 8 0 0 0 4-1 8 8 0 0 1-4 4 18 18 0 0 1-18 19 18 18 0 0 1-10-3 12 12 0 0 0 8-3 8 8 0 0 1-5-4 8 8 0 0 0 3-.5A8 8 0 0 1 0 12a8 8 0 0 0 3 1 8 8 0 0 1-1-9"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideMenu",
  props: {
    menu: {
      type: Object,
    },
  },
  data() {
    return {
      canShare: false,
      // canShare: navigator.share,
      buttons: [
        { icon: 'help', id: 'help' },
        { icon: 'settings', id: 'settings' },
        { icon: 'save', id: 'capture-video' },
      ]
    }
  },
  methods: {
    share() {
      navigator.share()
    }
  },
}
</script>

<style scoped>
.button-group1 {
  height: 100vh;
  display: table-cell;
  vertical-align: middle;
  top: -10vh;
  position: relative;
}
.bottom-button {
  display: block;
  position: relative;
  right: -1vh;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  width: 12vh;
  height: 10vh;
  background: linear-gradient(200deg,#e74a23,#e9671f,#ec841b,#efa118);
  border: 1vh solid white;
  color: white;

  margin: 2vh 0;
  padding: 0 4vh 0 3vh;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  box-shadow: 0.5vh -0.5vh 2vh rgba(0,0,0,0.3), -0.5vh -0.5vh 2vh rgba(0,0,0,0.1), 0.5vh 0.5vh 2vh rgba(0,0,0,0.1);
}
.material-icons-outlined {
  vertical-align: middle;
  display: inline;
  font-family: 'Material Icons';
  font-size: 5vh;
  line-height: 1;
  pointer-events: none;
  color: #fff;
}
.tweet-icon {
  fill: white;
  width: 5vh;
  height: 5vh;
}
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue